<template>
    <section>
        <b-overlay :show="loadingRtaList" no-wrap opacity="1">
        </b-overlay>
        <PageTitle :main="$t('rtaList')" sub="" imagem="rta/rtatable.svg" />
        <section>
            <section>
                <Filters @filter-changed="loadRtaList" @filter-reset="resetFilters" :headerToExport="tableColumns" :dataToExport="tableData" fileName="Lista de RTAs" :showExport="true" ref="tableOpenRta" />
            </section>
            <section>
                <Table ref="tableRta" :tableColumns="tableColumns" :tableData="tableData" :dbClickFunc="openRtaDetails" :hideColsArr="hideCols" />
            </section>
            <Overview :filters="overviewFilters" />
        </section>
        <b-modal id="rtaDetailsModal">
            <span>{{ this.rtaDetails.code }}</span>
        </b-modal>
    </section>
</template>

<script>
import axios from "axios";
import PageTitle from "../template/PageTitle.vue";
import Filters from "./commons/Filters.vue";
import Table from "./commons/Table.vue";
import Overview from "./commons/Overview.vue";
import { defaultSuccess, showError, urlMainAPI } from '../../global';
import * as moment from 'moment'
export default {
    name: "ConsultarRTA",
    components: { PageTitle, Filters, Table, Overview },
    data() {
        return {
            loadingRtaList: false,
            rtaDetails: {},
            hideCols: [],
            defaultFilters: {
                processId: null,
                workshiftId: null,
                startDate: "",
                endDate: "",
                indicatorId: null,
            },
            overviewFilters: null,
            tableColumns: [
                { field: "code", key: 'code', title: 'Código RTA', align: "center", sortBy: "", width: "5%", ellipsis: { lineClamp: 1 } },
                { field: "formattedCreationDate", key: 'formattedCreationDate', title: 'Data de Abertura', align: "center", sortBy: "", width: "10%", ellipsis: { lineClamp: 1 } },
                { field: "status", key: 'status', title: 'Status', align: "center", sortBy: "", width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "indicator", key: 'indicator', title: 'Indicador', align: "center", sortBy: "", width: "10%", ellipsis: { lineClamp: 1 } },
                { field: "process", key: 'process', title: 'Processo', align: "center", sortBy: "", width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "trigger", key: 'trigger', title: 'Gatilho', align: "center", sortBy: "", width: "7%", ellipsis: { lineClamp: 1 } },
                { field: "responsible", key: 'responsible', title: 'Responsável', align: "center", sortBy: "", width: "10%", ellipsis: { lineClamp: 1 } },
                { field: "workshift", key: 'workshift', title: 'Turno', align: "center", sortBy: "", width: "7%", ellipsis: { lineClamp: 1 } },
                { field: "relatedfca", key: 'relatedfca', title: 'FCAs Abertas', align: "center", sortBy: "", width: "10%", ellipsis: { lineClamp: 1 } },
                { field: "efficiencyrta", key: 'efficiencyrta', title: 'Eficácia da RTA', align: "center", sortBy: "", width: "10%", ellipsis: { lineClamp: 1 } },
                { field: "efficiencyaction", key: 'efficiencyaction', title: 'Efic. Plano de Ação', align: "center", sortBy: "", width: "10%", ellipsis: { lineClamp: 1 } },
                { field: "formattedDeadline", key: 'formattedDeadline', title: 'Prazo', align: "center", sortBy: "", width: "8%", ellipsis: { lineClamp: 1 } },
            ],
            tableData: [],
        }
    },
    methods: {
        async resetFilters() {
            if (this.$route.params.indicatorId) {
                this.$router.push({ name: 'rtalist' });
                this.defaultFilters = { ...this.defaultFilters, indicatorId: null };
            }
            
           this.$refs.tableRta?.resetAllColumnFilters();
           await this.loadRtaList(this.defaultFilters);
        },

        openRtaDetails(rtaInfo) {
            this.rtaDetails = { ...rtaInfo };

            this.rtaDetails.formattedCreationDate = moment(this.rtaDetails.creationDate).format("YYYY-MM-DD");
            this.rtaDetails.formattedDeadline = moment(this.rtaDetails.deadline).format("YYYY-MM-DD");


            this.$router.push({ name: "rtadetails", params: { rtaId: this.rtaDetails.code, rtaData: this.rtaDetails, isManual: false } }).catch(err => console.error(err));
        },

        async loadRtaConfig() {
            await axios.get(`${urlMainAPI}/getGeneralConfigGerencialIndicators`)
            .then(res => {
                const cfg = res.data;
                if (cfg.actionPlanRating !== 1) {
                    this.hideCols.push('efficiencyaction');
                }
                if (cfg.rtaRatingOff) {
                    this.hideCols.push('efficiencyrta');
                }
                defaultSuccess("Configurações Carregadas com Sucesso!");
            })
            .catch(err => {
                console.error(err);
                showError("Falha ao Carregar Configurações.");
            });
        },

        async loadRtaList(filters) {
            this.overviewFilters = filters;
            this.loadingRtaList = true;

            let url = `${urlMainAPI}/getopenrta`;
            let queryMount = [];

            if (filters.processId != null && filters.processId != undefined) queryMount.push(`processId=${filters.processId}`);
            if (filters.workshiftId != null && filters.workshiftId != undefined) queryMount.push(`workshiftId=${filters.workshiftId}`);
            if (filters.startDate != null && filters.startDate != undefined && filters.startDate != "" && filters.startDate != "Data inválida") queryMount.push(`startDate=${filters.startDate}`);
            if (filters.endDate != null && filters.endDate != undefined && filters.endDate != "" && filters.endDate != "Data inválida") queryMount.push(`endDate=${filters.endDate}`);
            if (filters.indicatorId != null && filters.indicatorId != undefined) queryMount.push(`indicatorId=${filters.indicatorId}`);
            if (queryMount.length > 0) url += `?${queryMount.join("&")}`

            await axios.get(url)
                .then(res => {
                    if (res.status == 200) {
                        this.tableData = res.data;
                        if (res.data.length == 0) defaultSuccess('Nenhuma RTA encontrada.')
                        else defaultSuccess('RTAs Carregadas.')
                    } else {
                        this.tableData = [];
                        defaultSuccess('Nenhuma RTA encontrada.')
                    }
                })
                .catch(err => console.error(err))

            this.loadingRtaList = false;

        },
    },

    async created() {
        await this.loadRtaConfig();
    },

    async mounted() {
        if (this.$route.params.indicatorId) {
            this.defaultFilters.indicatorId = this.$route.params.indicatorId;
        }
        await this.loadRtaList(this.defaultFilters);
    },
}
</script>

<style scoped></style>